import TrendKeywordMatchQuotas from './TrendKeywordMatchQuotas';


export default TrendKeywordMatchQuotas;
